import { mq, styled, css } from 'mymoria-ui/utils';
import { transparentize } from 'polished';
import React from 'react';

const PhoneWrapper = styled.div(
  ({ theme: { colors } }) => css`
    display: flex;
    background: ${transparentize(0.8, colors.white)};
    justify-content: center;
    align-items: center;
    border-radius: 3rem;

    ${mq({
      width: ['1.8rem', '1.8rem', '1.8rem', '4rem'],
      height: ['1.8rem', '1.8rem', '1.8rem', '4rem'],
      marginRight: ['0.5rem', '0.5rem', '0.5rem', '1rem'],
    })};

    img {
      margin: 0;

      ${mq({
        width: ['18px', '18px', '18px', '35px'],
        height: ['18px', '18px', '18px', '35px'],
      })};
    }
  `,
);

const PhoneIcon = () => (
  <PhoneWrapper>
    <img src="/img/ic_phone.svg" alt="phone" />
  </PhoneWrapper>
);

export default PhoneIcon;
